// test132
(132 && 0);
